import { useEffect } from 'react';

const PerformanceMonitor = () => {
  useEffect(() => {
    // 监控页面加载性能
    const measurePerformance = () => {
      if ('performance' in window) {
        const navigation = performance.getEntriesByType('navigation')[0];
        const paint = performance.getEntriesByType('paint');
        
        // 计算关键性能指标
        const metrics = {
          // 页面加载时间
          loadTime: navigation.loadEventEnd - navigation.loadEventStart,
          // DOM 内容加载时间
          domContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
          // 首次内容绘制
          firstContentfulPaint: paint.find(entry => entry.name === 'first-contentful-paint')?.startTime || 0,
          // 首次绘制
          firstPaint: paint.find(entry => entry.name === 'first-paint')?.startTime || 0,
          // 总页面大小
          transferSize: navigation.transferSize,
          // DNS 查询时间
          dnsTime: navigation.domainLookupEnd - navigation.domainLookupStart,
          // 连接时间
          connectTime: navigation.connectEnd - navigation.connectStart
        };
        
        // 在开发环境下输出性能指标
        if (process.env.NODE_ENV === 'development') {
          console.group('🚀 Performance Metrics');
          console.log('Page Load Time:', metrics.loadTime.toFixed(2) + 'ms');
          console.log('DOM Content Loaded:', metrics.domContentLoaded.toFixed(2) + 'ms');
          console.log('First Contentful Paint:', metrics.firstContentfulPaint.toFixed(2) + 'ms');
          console.log('First Paint:', metrics.firstPaint.toFixed(2) + 'ms');
          console.log('Transfer Size:', (metrics.transferSize / 1024).toFixed(2) + 'KB');
          console.log('DNS Time:', metrics.dnsTime.toFixed(2) + 'ms');
          console.log('Connect Time:', metrics.connectTime.toFixed(2) + 'ms');
          console.groupEnd();
          
          // 性能建议
          if (metrics.loadTime > 3000) {
            console.warn('⚠️ Page load time is over 3 seconds. Consider optimizing.');
          }
          if (metrics.firstContentfulPaint > 2500) {
            console.warn('⚠️ First Contentful Paint is over 2.5 seconds. Consider optimizing critical rendering path.');
          }
          if (metrics.transferSize > 1024 * 1024) {
            console.warn('⚠️ Page size is over 1MB. Consider code splitting and compression.');
          }
        }
        
        // 可以发送到分析服务
        // sendToAnalytics(metrics);
      }
    };
    
    // 页面加载完成后测量性能
    if (document.readyState === 'complete') {
      measurePerformance();
    } else {
      window.addEventListener('load', measurePerformance);
    }
    
    // 监控长任务
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.duration > 50) {
            console.warn(`⚠️ Long task detected: ${entry.duration.toFixed(2)}ms`);
          }
        }
      });
      
      try {
        observer.observe({ entryTypes: ['longtask'] });
      } catch (e) {
        // longtask not supported
      }
      
      return () => {
        observer.disconnect();
      };
    }
  }, []);
  
  return null; // 这是一个无UI的监控组件
};

export default PerformanceMonitor; 